import ErrorCodes from './errcode'

export function getMessage(code) {
    return ErrorCodes[code];
}
